import React, { createContext, useContext, useState, useCallback } from 'react';
import api from '../api/client';

const AuthContext = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const login = useCallback((userData) => {
    setUser(userData);
  }, []);

  const logout = useCallback(async () => {
    try { await api.post('/auth/logout'); } catch { /* ignore */ }
    api.setToken(null);
    setUser(null);
  }, []);

  const refreshProfile = useCallback(async () => {
    const token = api.getToken();
    if (!token) return null;
    try {
      const u = await api.get('/auth/me');
      setUser(u);
      return u;
    } catch {
      api.setToken(null);
      setUser(null);
      return null;
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, refreshProfile }}>
      {children}
    </AuthContext.Provider>
  );
};
